import Form from 'react-bootstrap/Form';
import React, { useState, useEffect } from "react";
import {useNavigate} from 'react-router-dom';
import PanelRedeemInfo from '../../../components/panel/non-payment-registration/PanelRedeemInfo.js';
import CollapsibleDiv from '../../../components/shared/CollapsibleDiv.js';
import ImageTitle from '../../../components/shared/ImageTitle.js';
import '../../../css/Stamp.css';

function NPStamp(props) {
   console.log(process.env.REACT_APP_ENV);
    const navigate = useNavigate();
    const PUBLIC_URL =process.env.PUBLIC_URL;
    const eventName = window.name;
    const url = new URL(window.location.href);
    let baseUrl = `${url.protocol}//${url.host}/`;

    if (process.env.REACT_APP_API_URL != ""){
      baseUrl = process.env.REACT_APP_API_URL;
    }
    const bgColor = process.env.REACT_APP_BG_COLOR;
    const stampUrl = baseUrl + "frontend/api/NPEnroll/GetStampInfo";
    const pickupIconUrl = process.env.REACT_APP_URL_IMAGE + "stamp_icon.png";
    const [itemDetails, setItemDetails] = useState([]);
    const [content, setContent] = useState({
      Event_PromoName: "",
      Event_Url_Name: "",
      Geocode: "",
      Mobile: "",
      Pickup_Location: "",
      Pickup_Adress: "",
      Invoice_no: "",
      Stamp_TnC: "",
      Stamp_Picture: "",
      Stamp_QRCode_Icon: "",
      Stamp_Code: "",
      Stamp_Start_Date: "",
      Stamp_End_Date: "",
      Stamp_Pickup_Method: "",
      Stamp_Prefix: "",
      Event_Version: ""
    });

    if(props.isdebugmode) console.log(baseUrl);
    
    if(props.code === ""){
      navigate('../../../' + PUBLIC_URL + '/fail-wrong-url');
    } 

    useEffect(() => {
      fetch(stampUrl, {
        "method": "POST",
        "headers": {
          'Content-Type': 'application/json'
        },
        "body": JSON.stringify({
          "Event_Name": eventName,
          "SMS_Code": props.code
        })
      })
      .then(response => response.json())
      .then(response => {         
        let result = JSON.parse(JSON.stringify(response));
        if(props.isdebugmode) console.log(result);
        if (result.IsSuccess == null){

          //if(props.isdebugmode) console.log(result.Item_Detail[0].Stock_Code);
          //if(props.isdebugmode) console.log(result.Event_Url_Name);
//Added by Joanne 20250606
          if (result.Event_Url_Name == "2025062122_internal_carnival" || result.Event_Url_Name == "2025062122_carnival")
          {
            result.Stamp_Prefix = result.Stamp_Prefix.replace("cas01005",result.Item_Detail[0].Stock_Code);
            result.Stamp_Prefix = result.Stamp_Prefix.replace("cas01007",result.Item_Detail[0].Stock_Code);
          }
          else if (result.Event_Url_Name == "2025_tasting_certificate")
          {
            if (result.Item_Detail.length !== 0)
            {
              result.Stamp_Prefix = result.Stamp_Prefix.replace("cas01010",result.Item_Detail[0].Stock_Code);
            }
            else
            {
                navigate('../../../' + PUBLIC_URL + '/fail-wrong-expired-stamp');
            }
          }
          else if (result.Event_Url_Name == "2025_tasting_certificate2")
          {
            if (result.Item_Detail.length !== 0)
              {
                result.Stamp_Prefix = result.Stamp_Prefix.replace("cas01014",result.Item_Detail[0].Stock_Code);
              }
            else
              {
                  navigate('../../../' + PUBLIC_URL + '/fail-wrong-expired-stamp');
              }
          }

          if (result.Event_Url_Name == "2026032829_TSTopening")
          {
            result.Stamp_Prefix = result.Stamp_Prefix.replace("cas01038",result.Item_Detail[0].Stock_Code);
          }
          //if(props.isdebugmode) console.log(result.Stamp_Prefix);


          setContent(previousState => {
          return { 
            ...previousState,
            Event_PromoName : result.Event_PromoName,
            Event_Url_Name : result.Event_Url_Name,
            Geocode : result.Geocode,
            Mobile : result.Mobile,
            Pickup_Location : result.Pickup_Location,
            Pickup_Adress : result.Pickup_Adress,
            Invoice_no : result.Invoice_no,
            Stamp_TnC : result.Stamp_TnC,
            Stamp_Picture : result.Stamp_Picture,
            allTitle_FontColor : result.AllTitle_FontColor,
            Stamp_QRCode_Icon : result.Stamp_QRCode_Icon,
            Stamp_Code : result.Stamp_Code,
            Stamp_Start_Date : result.Stamp_Start_Date,
            Stamp_End_Date : result.Stamp_End_Date,
            Stamp_Pickup_Method : result.Stamp_Pickup_Method,
            Stamp_Prefix : result.Stamp_Prefix,
            Event_Version : result.Event_Version
            }
          });

          // Redirect to enroll page if it is not non-payment event
          if (result.Event_Version != 3){
            navigate('../../../' + PUBLIC_URL + '/' + eventName + '/enroll');
          }

          let items = []; 
          for (let i = 0; i < result.Item_Detail.length; i++)
          {
            items.push(result.Item_Detail[i]);
          }
          setItemDetails(items);
        } else {
          navigate('../../../' + PUBLIC_URL + '/fail-wrong-url');
        }
      })
      .catch(err => { 
        //navigate('../../../' + PUBLIC_URL + '/' + eventName + '/fail-error');
        if(props.isdebugmode) console.log(err); 
      });
    }, []);
    
    let stampPickup = "<div className='pickup-logo'><img src='" + pickupIconUrl + "'/>請向店員出示本電子印花</div>";

 
  return (
    <>
      <Form>
        {content.Stamp_Picture !== "" && 
          <div className="d-grid">
              <ImageTitle src={content.Stamp_Picture} alt="logo" />
              <div style={{backgroundColor: bgColor}}>
                <PanelRedeemInfo data={content} stock={itemDetails}></PanelRedeemInfo>
              </div>
              <CollapsibleDiv title="電子印花使用方法"  content={{__html: stampPickup}}></CollapsibleDiv>
              <CollapsibleDiv title="使用條款及細則" content={{__html: content.Stamp_TnC}}></CollapsibleDiv>
          </div>
        }
      </Form>
    </>
  );
}

export default NPStamp;